import { CreateOrUpdateOrganization } from "@/routes/admin/organization/createOrUpdateOrganization";

function CreateOrganizationPage() {
  return <CreateOrUpdateOrganization organization={null} />;
}

export default CreateOrganizationPage;
